import { render } from "./TablePayrunType.vue?vue&type=template&id=b5b0f202&scoped=true"
import script from "./TablePayrunType.vue?vue&type=script&lang=js"
export * from "./TablePayrunType.vue?vue&type=script&lang=js"

import "./TablePayrunType.vue?vue&type=style&index=0&id=b5b0f202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b0f202"]])

export default __exports__